import { render, staticRenderFns } from "./Whale.vue?vue&type=template&id=28f58960&scoped=true"
import script from "./Whale.vue?vue&type=script&lang=js"
export * from "./Whale.vue?vue&type=script&lang=js"
import style0 from "./Whale.vue?vue&type=style&index=0&id=28f58960&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f58960",
  null
  
)

export default component.exports